export default "__VITE_ASSET__DPdO3dBm__"